/* -------------------------------------------

	Name:		Vloerkledenwinkel.nl
	Date:		2020/05/17
	Author:		http://psdhtml.me

---------------------------------------------  */
/*global jQuery, document, yall, setTimeout */

var i = 0,
  img_lazy = document.querySelectorAll('img[data-src]:not(.dont)');
for (i = 0; i < img_lazy.length; i = i + 1) {
  img_lazy[i].classList.add('lazy');
}

$(function($) {
  if ($('.price').length) {
    $('.price').each(function () {
      var old_price = $(this).find('.old'),
          diff_price = $(this).find('.diff'),
          price = $(this);
      var addSup = function(el) {
        el.html(function(i, html){
          return html.trim().replace( /(\,\d+)$/, '<sup>$1</sup>')
        });
      }
      if (old_price) {
        addSup(old_price);
      }
      if (diff_price) {
        addSup(diff_price);
      }
      addSup(price);
    })
  }
})


document.addEventListener('DOMContentLoaded', function() {
  'use strict';
  yall({
    observeChanges: true,
    threshold: 500
  });

  if (jQuery('body').hasClass('template-product')) {
  	setTimeout(addRoomvo, 3000);
  }
  if (!jQuery('body').hasClass('template-product')) {
    setTimeout(addSwym, 3000);
  }

});

$('.tabletClick').click(function(e){
  
  const userAgent = navigator.userAgent.toLowerCase();
  const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
  
  if(isTablet || isTouchDevice()){
    
    if($('#nav>ul>li>.megamenu>li .toggle').css('display') == 'none'){
    
    $('#nav>ul>li>ul').css({ "display": "block" });
    
    $('#nav > ul > li:hover > ul').css({ "display": "block" });
    $('#nav > ul > li.sub:hover ~ .shadow').css({ "opacity": ".5", "display": "block", "position": "absolute", "left": "-1000em", "right": "-1000em", "top": "100%","height": "100vh", "background": "var(--coal)"}); 
	
    $('#nav>ul>li>.megamenu>li .toggle').css("display","block");
    
    $('#nav > ul > li:hover > ul.megamenu').css({ "display": "flex", "padding-bottom": "50px"});

    }else{
      $('#nav>ul>li>ul').css({ "display": "none" });
      $('#nav>ul>li>.megamenu>li .toggle').css("display","none");
      $('.shadow').css('display', 'none');
      
    }
    
    e.stopPropagation();
    return false;    
    
    
    
    
  }

});

function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

jQuery(function() {

  "use strict";
  var
    $ = jQuery.noConflict(),
    html_tag = document.documentElement,
    body_tag = $(document.getElementsByTagName('body'));

  var related_products = $(document.getElementsByClassName('related-products'));
  if (related_products.length) {
    var tag = related_products.data('tag'),
      url = "/collections/all/" + tag,
      feed = [],
      el = "",
      items = "";
    $.get(url).then(
      function(data) {
        var length = $(data).find('.list-collection > .boost-pfs-filter-product-item').length;

        $(data).find('.list-collection > .boost-pfs-filter-product-item').each(function() {
          var item_url = $(this).find('.boost-pfs-filter-product-item-image-link').attr('href'),
            item_title = $(this).find('.boost-pfs-filter-product-item-title').text(),
            item_img = $(this).find('img').attr('data-src').replace( '_360x', '_170x210');

            /*
          if (length > 3) {
            var item_el = "<li><a href='" + item_url + "'><img class='dont owl-lazy' data-src=" + item_img + " alt='" + item_title + "' width='115' height='155'></a></li>";
          } else {
            var item_el = "<li><a href='" + item_url + "'><img class='lazy' data-src=" + item_img + " alt='" + item_title + "' width='115' height='155'></a></li>";
          }
          */

          var item_el = "<li><a href='" + item_url + "'><img class='lazy' data-src=" + item_img + " alt='" + item_title + "' width='115' height='155'></a></li>";

          
          related_products.append(item_el);
        })

        if ($(data).find('.list-collection > .boost-pfs-filter-product-item').length) {
          related_products.removeClass('hidden').css('opacity', 0);
          body_tag.trigger('lazyload-again', [related_products]);
          body_tag.trigger('list-gallery-slider');
          $('.related-products-count').text($(data).find('.list-collection > .boost-pfs-filter-product-item').length).parent().removeClass('hidden');
          related_products.css('opacity', 1);
        }
      }.bind(this)
    );
  }

    $(document).ready(function() {
        $('body').click(function (event) {
            if(!$(event.target).closest('#loginForm, .openButton').length && !$(event.target).is('.transparent-back')) {
                if (document.getElementById("loginForm")) {
                    var target = document.getElementById("loginForm");
                    target.style.display = "none";
                }
            }}
        )});

  $(document).ready(function(){ 
    window.onscroll = function() {
      var scrollLimit = 60;
      if (window.scrollY > scrollLimit) {
        $("div#shopify-section-message-bar").css("z-index","-10");
      }
      else {
        $("div#shopify-section-message-bar").css("z-index","10");
      }
    };
  });

  var footer_id = document.getElementById('footer'),
    footer_date = footer_id ? footer_id.querySelectorAll('.date') : [],
    accordion_a = $(document.getElementsByClassName('accordion-a')),
    cols_class = $(document.getElementsByClassName('cols-a')).add($(document.getElementsByClassName('cols-b'))),
    email_tag = document.getElementsByClassName('email'),
    input_tag = $(document.getElementsByTagName('input')),
    select_tag = $(document.getElementsByTagName('select')),
    list_box = $(document.getElementsByClassName('list-box')),
    list_collection = $(document.getElementsByClassName('list-collection')),
    list_comments = $(document.getElementsByClassName('list-comments')),
    list_featured = $(document.getElementsByClassName('list-featured')),
    moodboard = $(document.getElementsByClassName('moodboard')),
    list_gallery = $(document.getElementsByClassName('list-gallery')),
    list_product = $(document.getElementsByClassName('list-product')),
    list_rating = $(document.getElementsByClassName('list-rating')),
    rating_a = $(document.getElementsByClassName('rating-a')),
    tabs_a = $(document.getElementsByClassName('tabs-a')),
    tabs_b = $(document.getElementsByClassName('tabs-b')),
    ui_slider_a = $(document.getElementsByClassName('ui-slider-a')),

    singleStar = function() {
      return $('<span class="star"><span class="fill"></span></span>');
    },

    Default = {
      utils: {
        mails: function() {
          if (email_tag.length) {
            Array.from(email_tag).filter(function(el) {
              return el.tagName !== 'INPUT' && el.tagName !== 'DIV';
            }).forEach(function(el) {
              el.innerText = el.innerText.replace('//', '@').replace(/\//g, '.');
              if (el.tagName === 'A') {
                el.setAttribute('href', 'mailto:' + el.innerText);
              }
            });
          }
        },
        forms: function() {
          input_tag.filter('[required]').prev('label').append('<span class="required">*</span>');
          select_tag.filter('[required]').prev('label').append('<span class="required">*</span>');  
        },
        date: function() {
          if (footer_date.length) {
            footer_date[0].innerText = (new Date()).getFullYear();
          }
        },
        ratings: function() {
          body_tag.on("ratings", function(event) {
            var rating_a = $(document.getElementsByClassName('rating-a'));
            if (rating_a.length) {
              rating_a.wrapInner('<span class="label"></span>').prepend('<span class="rating"></span>').each(function() {
                var i = 1,
                  ss,
                  rateContainer = $(this),
                  maxStars = $(this).attr('data-of'),
                  rate = rateContainer.data('val').toString().split('.');
                while (i <= maxStars) {
                  ss = singleStar();
                  rateContainer.children('.rating').append(ss);
                  if (i <= rate[0]) {
                    ss.children().css('width', '100%');
                  } else if (+rate[1] > 0) {
                    ss.children().css('width', (rate[1] * (rate[1].length === 1 ? 10 : 1)) + '%');
                    rate[1] = 0;
                  }
                  i = i + 1;
                }
              });
            }
          })
          body_tag.trigger('ratings');
        },
        mobile: function() {
          if (jQuery.browser.mobile) {
            html_tag.classList.add('mobile');
          } else {
            html_tag.classList.add('no-mobile');
          }
        },
        owl: function() {
          if (list_comments.length) {
            list_comments.each(function() {
              if ($(this).children().length > 2) {
                $(this).owlLayout().children('.inner').owlCarousel({
                  loop: false,
                  nav: true,
                  dots: true,
                  autoHeight: true,
                  lazyLoad: true,
                  margin: 20,
                  items: 1,
                  onInitialized: function() {
                    $(this.$element).owlSemantic();
                  },
                  onTranslated: function() {
                    $(this.$element).owlSemantic();
                  },
                  responsive: {
                    0: {
                      items: 1
                    },
                    760: {
                      items: 2
                    },
                    1400: {
                      items: 1
                    }
                  }
                });
              }
            });
          }
          body_tag.on('list-gallery-slider', function() {
            list_gallery = $(document.getElementsByClassName('list-gallery'));
            if (list_gallery.length) {
              list_gallery.filter('.slider').each(function() {
                if ($(this).children().length > 3) {
                  $(this).owlLayout().children('.inner').owlCarousel({
                    loop: false,
                    nav: true,
                    dots: true,
                    autoHeight: true,
                    autoWidth: true,
                    lazyLoad: true,
                    margin: 17,
                    items: 5,
                    onInitialized: function() {
                      $(this.$element).owlSemantic();
                    },
                    onTranslated: function() {
                      $(this.$element).owlSemantic();
                    },
                    responsive: {
                      0: {
                        items: 2,
                        margin: 10
                      },
                      760: {
                        items: 3,
                        margin: 17
                      },
                      1000: {
                        items: 4,
                        margin: 17
                      },
                      1400: {
                        items: 5,
                        margin: 17
                      }
                    }
                  });
                }
              });
            }
          })
          body_tag.trigger('list-gallery-slider');
          body_tag.on('list-collection-slider', function() {
            list_collection = $(document.getElementsByClassName('list-collection'));
            if (list_collection.length) {
              cols_class.find('.list-collection').addClass('in-cols');
              list_collection.find('.list-featured').addClass('in-collection');
              list_collection.each(function() {
                $(this).children('li').addClass('cont');
                $(this).filter('.slider:not(.in-cols):not(#recently-viewed-products)').each(function() {
                  var $this = $(this);
                  if ($(this).children().length > 2) {
                    $(this).owlLayout().children('.inner').owlCarousel({
                      loop: false,
                      nav: true,
                      dots: false,
                      autoHeight: true,
                      lazyLoad: true,
                      margin: ($(this).is('.box') ? 18 : 22),
                      items: 4,
                      onInitialized: function() {
                        $(this.$element).owlSemantic();
                      },
                      onTranslated: function() {
                        $(this.$element).owlSemantic();
                      },
                      responsive: {
                        0: {
                          items: 1,
                          margin: 0
                        },
                        760: {
                          items: 3,
                          margin: 0
                        },
                        1000: {
                          items: 4,
                          margin: 0
                        },
                        1400: {
                          items: 4,
                          margin: ($(this).is('.box') ? 18 : 22)
                        }
                      }
                    });
                  }
                });
                $(this).filter('.slider.in-cols').each(function() {
                  if ($(this).children().length > 3) {
                    $(this).owlLayout().children('.inner').owlCarousel({
                      loop: false,
                      nav: true,
                      dots: false,
                      autoHeight: true,
                      lazyLoad: true,
                      margin: ($(this).is('.box') ? 18 : 22),
                      items: 3,
                      onInitialized: function() {
                        $(this.$element).owlSemantic();
                      },
                      onTranslated: function() {
                        $(this.$element).owlSemantic();
                      },
                      responsive: {
                        0: {
                          items: 1,
                          margin: 0
                        },
                        760: {
                          items: 2,
                          margin: 0
                        },
                        1200: {
                          items: 3,
                          margin: ($(this).is('.box') ? 18 : 22)
                        }
                      }
                    });
                  }
                });
                $(this).filter('.small').each(function() {
                  if ($(this).children().length > 1) {
                    $(this).addClass('mobile-hide').clone().removeClass('mobile-hide').addClass('mobile-only').insertAfter($(this));
                    $(this).next('.list-collection.mobile-only').owlLayout().children('.inner').owlCarousel({
                      loop: false,
                      nav: true,
                      dots: false,
                      autoHeight: true,
                      lazyLoad: true,
                      margin: ($(this).is('.box') ? 18 : 22),
                      items: 1,
                      onInitialized: function() {
                        $(this.$element).owlSemantic();
                      },
                      onTranslated: function() {
                        $(this.$element).owlSemantic();
                      }
                    });
                  }
                });
              });
            }
          })
          body_tag.trigger('list-collection-slider');
          if (list_featured.length) {
            body_tag.on('list-featured-slider', function() {
              list_featured = $(document.getElementsByClassName('list-featured'));
              list_featured.each(function() {
                if ($(this).is('.slider') && !$(this).is('.featured-brands-ul') && $(this).children().length > 3) {
                  $(this).owlLayout().children('.inner').owlCarousel({
                    loop: false,
                    nav: true,
                    dots: false,
                    autoHeight: true,
                    lazyLoad: true,
                    margin: 20,
                    items: 3,
                    onInitialized: function() {
                      $(this.$element).owlSemantic();
                    },
                    onTranslated: function() {
                      $(this.$element).owlSemantic();
                    },
                    responsive: {
                      0: {
                        items: 1,
                        margin: 10
                      },
                      760: {
                        items: 3,
                        margin: 20
                      }
                    }
                  });
                } else if ($(this).is('.slider') && $(this).is('.featured-brands-ul') && $(this).children().length > 3) {
                    $(this).owlLayout().children('.inner').owlCarousel({
                        loop: true,
                        nav: true,
                        dots: false,
                        autoHeight: true,
                        lazyLoad: true,
                        margin: 20,
                        items: 1,
                        onInitialized: function() {
                            $(this.$element).owlSemantic();
                        },
                        onTranslated: function() {
                            $(this.$element).owlSemantic();
                        },
                        responsive: {
                            0: {
                                items: 1.5,
                                margin: 18
                            },
                            760: {
                                items: 3,
                                margin: 41
                            }
                        }
                    });
                }
                if ($(this).is(':not(.slider, .mobile-only, .in-collection, .blogs)') && $(this).children().length > 1) {
                  $(this).addClass('mobile-hide').clone().removeClass('mobile-hide').addClass('mobile-only').insertAfter($(this));
                  $(this).next('.list-featured.mobile-only').find('.link-more, .small').remove();
                  $(this).next('.list-featured.mobile-only').owlLayout().children('.inner').owlCarousel({
                    loop: false,
                    nav: true,
                    dots: false,
                    autoHeight: true,
                    lazyLoad: true,
                    margin: 10,
                    items: 1,
                    onInitialized: function() {
                      $(this.$element).owlSemantic();
                    },
                    onTranslated: function() {
                      $(this.$element).owlSemantic();
                    }
                  });
                }
              });
            })
            body_tag.trigger('list-featured-slider');
            body_tag.on('banner-grid', function() {
              list_featured = $(document.getElementsByClassName('list-featured'));
              var elems = list_featured.filter('.welcome:not(.mobile-only)'), count = elems.length;
              elems.each(function() {
                $(this).isotope({
                  masonry: {
                    columnWidth: 1
                  }
                });
                if (!--count) {
                  elems.css("opacity", "1");
                }
              });
            })
            body_tag.trigger('banner-grid');
          }

          body_tag.trigger('list-moodboard-slider');
          if (moodboard.length) {
              body_tag.on('list-moodboard-slider', function() {
                  moodboard = $(document.getElementsByClassName('moodboard'));
                  moodboard.each(function() {
                      if ($(this).is('.slider') && $(this).children().length > 1) {
                          $(this).owlLayout().children('.inner').owlCarousel({
                              loop: false,
                              nav: true,
                              dots: false,
                              autoHeight: true,
                              lazyLoad: true,
                              margin: 20,
                              items: 1,
                              onInitialized: function() {
                                  $(this.$element).owlSemantic();
                              },
                              onTranslated: function() {
                                  $(this.$element).owlSemantic();
                              },
                              responsive: {
                                  0: {
                                      items: 1,
                                      margin: 10
                                  },
                                  760: {
                                      items: 1,
                                      margin: 20
                                  }
                              }
                          });
                      }
                      if ($(this).is(':not(.slider, .mobile-only, .in-collection, .blogs)') && $(this).children().length > 1) {
                          $(this).addClass('mobile-hide').clone().removeClass('mobile-hide').addClass('mobile-only').insertAfter($(this));
                          $(this).next('.list-featured.mobile-only').find('.link-more, .small').remove();
                          $(this).next('.list-featured.mobile-only').owlLayout().children('.inner').owlCarousel({
                              loop: false,
                              nav: true,
                              dots: false,
                              autoHeight: true,
                              lazyLoad: true,
                              margin: 10,
                              items: 1,
                              onInitialized: function() {
                                  $(this.$element).owlSemantic();
                              },
                              onTranslated: function() {
                                  $(this.$element).owlSemantic();
                              }
                          });
                      }
                  });
              })
              body_tag.trigger('list-moodboard-slider');
              body_tag.on('banner-grid', function() {
                  moodboard = $(document.getElementsByClassName('moodboard'));
                  var elems = list_featured.filter('.welcome:not(.mobile-only)'), count = elems.length;
                  elems.each(function() {
                      $(this).isotope({
                          masonry: {
                              columnWidth: 1
                          }
                      });
                      if (!--count) {
                          elems.css("opacity", "1");
                      }
                  });
              })
              body_tag.trigger('banner-grid');
          }

          if (list_box.length) {
            list_box.filter('.slider').each(function() {
              if ($(this).children().length > 3) {
                $(this).owlLayout().children('.inner').owlCarousel({
                  loop: false,
                  nav: true,
                  dots: false,
                  autoHeight: true,
                  lazyLoad: true,
                  margin: 10,
                  items: 3,
                  onInitialized: function() {
                    $(this.$element).owlSemantic();
                  },
                  onTranslated: function() {
                    $(this.$element).owlSemantic();
                  },
                  responsive: {
                    0: {
                      items: 1
                    },
                    760: {
                      items: 4
                    },
                    1000: {
                      items: 5
                    },
                    1200: {
                      items: 6
                    },
                    1400: {
                      items: 7
                    }
                  }
                });
              }
            });
          }
          body_tag.on('list-rating-slider', function() {
            list_rating = $(document.getElementsByClassName('list-rating'));
            if (list_rating.length) {
              list_rating.each(function() {
                if ($(this).children().length > 1) {
                  $(this).owlLayout().children('.inner').owlCarousel({
                    loop: false,
                    nav: true,
                    dots: true,
                    autoHeight: true,
                    lazyLoad: true,
                    margin: 20,
                    items: 1,
                    onInitialized: function() {
                      $(this.$element).owlSemantic();
                    },
                    onTranslated: function() {
                      $(this.$element).owlSemantic();
                    }
                  });
                }
              });
            }
          })
          body_tag.trigger('list-rating-slider');
          body_tag.on('list-product-slider', function(event) {
            var list_product = $(document.getElementsByClassName('list-product'));
            if (list_product.length) {
              list_product.not('.is-slider').each(function() {
                if ($(this).children().not('ul').not('.zoom').length > 1) {
                  $(this).owlLayout();
                  var zoom = $(this).parent().find('.zoom').appendTo($(this));
                  $(this).append('<ul class="pager custom"></ul>').children('.inner').children().each(function(i) {
                    $(this).find('li:not(.link-more) img:first').clone().wrap('<a href="./" role="button" data-slide-index="' + i + '"></a>').parent().appendTo($(this).parents('.is-slider:first').find('.pager.custom'));
                  });
                  if ($(this).is('.with-video')) { $(this).find('.pager').prepend('<li><a data-fancybox-group="gallery" href="' + $(this).data('video') + '"><i class="icon-play"></i></a></li>'); }
                  $(this).find('.pager .dont').removeClass('dont').each(function() { $(this).attr('src', $(this).attr('data-src').replace('_260x400', '_75x75')).removeAttr('data-src'); });
                  $(this).find('.dont').removeClass('dont').addClass('owl-lazy');
                  $(this).children('.inner').owlCarousel({
                    nav: true,
                    dots: true,
                    autoHeight: false,
                    loop: false,
                    lazyLoad: true,
                    items: 1,
                    margin: 0,
                    onInitialized: function() {
                      $(this.$element).owlSemantic();
                      $('.slider').trigger('refresh.owl.carousel')
                    },
                    onTranslated: function(event) {
                      $(this.$element).owlSemantic();
                      $(this.$element).parents('.is-slider:first').find('[data-slide-index]').removeClass('current').parent().children('[data-slide-index="' + event.item.index + '"]').addClass('current');
                    }
                  });
                  $(this).find('a[data-slide-index]').wrap('<li></li>').each(function() {
                    if ($(this).parent().is(':first-child')) {
                      $(this).addClass('current').attr('aria-pressed', true);
                    } else {
                      $(this).attr('aria-pressed', false);
                    }
                  }).on('click', function() {
                    var n = $(this),
                      f = n.parents('.is-slider:first');
                    f.find('.pager a[data-slide-index]').each(function(k, v) {
                      if ((v = $(v)).is('[data-slide-index="' + n.attr('data-slide-index') + '"]')) {
                        v.attr('aria-pressed', true).addClass('current');
                      } else {
                        v.attr('aria-pressed', false).removeClass('current');
                      }
                    });
                    f.find('.owl-carousel:first').trigger('to.owl.carousel', n.attr('data-slide-index'));
                    return false;
                  });
                  var zoom = $(this).find('.zoom').appendTo($(this).find('.owl-carousel'));
                  var pager = $(this).find('.pager.custom');
                  var pagerItems = pager.children();
                  if ( $(window).width() < 1000 ) {
                    var pagerItemsLength = 4;
                  } else {
                    var pagerItemsLength = 5;
                  }
                  var pagerItemsLengthMinusOne = pagerItemsLength - 1;
                  if (pagerItems.length > pagerItemsLength) {
                    $(this).find('.pager.custom > *:gt('+pagerItemsLengthMinusOne+')').hide();
                    $(this).find('.pager.custom > *:nth-child('+pagerItemsLength+')').addClass('more').append('<span>+'+ (pagerItems.length - pagerItemsLength) +'</span>');
                  }
                } else {
                  var zoom = $(this).parent().find('.zoom').appendTo($(this));
                }
                $(this).find('li ul, li > span.label').appendTo($(this));
              });
            }
          })
          body_tag.trigger('list-product-slider');
          if ( $(window).width() < 1201 ) {
            $('.list-usp').each(function(){
              if ($(this).parent().is("#top")) { var mobileItems = 1; } else { var mobileItems = 3; }
              $(this).owlCarousel({
                nav: false,
                dots: false,
                autoHeight: false,
                autoWidth: true,
                autoplay: true,
                autoplayTimeout: 2500,
                loop: true,
                items: 1,
                margin: 0,
                responsive: {
                  575: {
                    items: mobileItems
                  },
                  1000: {
                    items: 5
                  },
                }
              });
            });
          }
          if ( $(window).width() < 1001 ) {
            $('.text-blocks .list-featured').each(function(){
              $(this).owlCarousel({
                nav: false,
                dots: false,
                autoHeight: false,
                autoWidth: true,
                loop: true,
                items: 1,
                margin: 10,
                responsive: {
                  575: {
                    items: 3,
                    margin: 18
                  },
                }
              });
            });
          } else {
            $('.text-blocks .list-featured').removeClass('owl-carousel');
          }
        },
        done: function() {
          var tag = document.createElement('script');
          tag.src = "//b2b-vloerkledenwinkel.myshopify.com/cdn/shop/t/65/assets/scripts-async.js?v=128699456966034628171727428187";
          tag.setAttribute('defer','');
          tag.setAttribute('async','');
          document.body.appendChild(tag);
        },
        miscellaneous: function() {
          body_tag.on('lazyload-again', function(event, element) {
          	element.find('img:not(.dont)').each(function() {$(this).addClass('lazy');});
            yall();
          })
          $(footer_id).each(function() {
            $(this).find('.list-social').clone().addClass('mobile-only').insertAfter($(this).find('form'));
            $(this).children('div').children('.list').each(function(){
              $(this).addClass('mobile-hide').clone().removeClass('mobile-hide').addClass('mobile-only').insertBefore($(this).parent().find('.seperator'));
            });
            $(this).find('.expand').parent().addClass('expanded');
            $(this).find(':header').not('.expand').append('<a class="header-toggle" href="./"></a>').children('a.header-toggle').on('click', function() {
              $(this).closest(':header').toggleClass('header-toggle');
              return false;
            });
          });
          $('.tab-item').each(function() {
            $(this).find(':header').append('<a class="header-toggle" href="./"></a>').children('a.header-toggle').on('click', function() {
              $(this).closest(':header').toggleClass('header-toggle');
              
              if ($(this).closest(':header').hasClass('header-toggle')) {
                $(this).closest('.read-more').removeClass('no-height');
              } else {
                $(this).closest('.read-more').addClass('no-height');
              }
              return false;
            });
            if ($(this).hasClass('toggle')) {
              $(this).children(':header').first().toggleClass('header-toggle');
            }
          })
          $('.read-more').each(function() {
            var toggleHeight = 275;
            var enable = true;
            if ($(this).hasClass('read-more-mobile') && $(window).width() > 759) {
              enable = false;
            } 
            if ( $(window).width() < 760 ) {
            	toggleHeight = 210;
            };
            if ($(this).attr('data-toggleHeight')) { toggleHeight = $(this).attr('data-toggleHeight'); }
            if (enable) {
              if ($(this).outerHeight() > toggleHeight) {
                $(this).attr('data-height', ($(this).outerHeight() + 30)).addClass('enabled').append('<a class="more-toggle" href="./"><span>Toon meer</span></a>').children('a.more-toggle').on('click', function() {
                  var parent = $(this).parent('.read-more');
                  parent.toggleClass('more-toggled');

                  if (parent.hasClass('more-toggled')) {
                    $(this).html("<span>Toon minder</span>");
                    parent.css('height', parent.data('height'));
                    setTimeout(function(){ parent.addClass('done'); }, 500);
                  } else {
                    $(this).html("<span>Toon meer</span>");
                    parent.removeClass('done');
                    setTimeout(function(){ parent.css('height', toggleHeight); }, 0);
                  }
                  return false;
                });
              } else {
                $(this).removeClass('read-more');
              }
            }
        
          })
          body_tag.on('accordion-a', function () {
            accordion_a = $(document.getElementsByClassName('accordion-a'));
            if (accordion_a.length) {
              accordion_a.semanticAccordion();
            }
          })
          body_tag.trigger('accordion-a');
          if (tabs_a.length || tabs_b.length) {
            tabs_a.add(tabs_b).semanticTabs();
          }
          if (ui_slider_a.length) {
            ui_slider_a.each(function() {
              var self = $(this);
              $(this).append('<div class="slider"><div class="inner"></div></div>').find('.slider .inner').slider({
                range: true,
                min: +self.find('[min]').attr('min'),
                max: +self.find('[max]').attr('max'),
                values: [+self.find('input:first').val(), +self.find('input:last').val()],
                slide: function(event, ui) {
                  self.find('input:first').val(ui.values[0]);
                  self.find('input:last').val(ui.values[1]);
                }
              });
            });
          }
          var textToggle = $('.text-toggle .link-more');
          textToggle.click(function() {
            $(this).parent().find('.text').toggle();
            textToggle.toggleClass('hidden');
          });
          var registerBtn = $('.form-login button.toggle-form');
          registerBtn.click(function(e){
            e.preventDefault();
            $(this).hide();
            $(this).parent().find('.form-wrapper').show();
          });
        }
      }

    };
  setTimeout(function() {
    Default.utils.mails();
    Default.utils.forms();
    Default.utils.date();
    Default.utils.ratings();
    Default.utils.miscellaneous();
    Default.utils.owl();
    Default.utils.mobile();
    Default.utils.done();
  }, 0);

});


function addTrengo() {
  if (window.Trengo == undefined) {
    window.Trengo = window.Trengo || {};
    window.Trengo.key = 'WUYE7j4yHDS3P3oPjPGY';
    (function(d, script, t) {
        script = d.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://static.widget.trengo.eu/embed.js';
        d.getElementsByTagName('head')[0].appendChild(script);
    }(document));
   }
}

function addRoomvo() {
  (function(d, script, t) {
      script = d.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://www.roomvo.com/static/scripts/b2b/vloerkledenwinkelnl.js';
      d.getElementsByTagName('head')[0].appendChild(script);
  }(document));
}

function addSwym() {

  // part one
  window.swymLandingURL = document.URL;
  (function loadSwymFaster(){
    var elScripts = document.querySelectorAll("script:not([src]):not([class]):not([id])"), scriptLoadScript, scriptLoadScriptText;
    for(var i = 0; i < elScripts.length; i++){
      var elScript = elScripts[i];
      // TODO change swym- check to script metafield
      if(elScript.innerText.indexOf('swym-shopify.js') > -1){
        scriptLoadScriptText = elScript.innerText;
        break;
      }
    }
    if(scriptLoadScriptText) {
      var startStr = 'var urls =';
      var startIdx = scriptLoadScriptText.indexOf(startStr);
      var endStr = '"];';
      var endIdx = scriptLoadScriptText.indexOf(endStr,startIdx);
      var listOfUrlsText = scriptLoadScriptText.slice(startIdx + startStr.length, endIdx + endStr.length);
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = (null || "//swymprod.azureedge.net/code/swym-shopify.js") + "?shop=";
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
  })();
  window.swymCart = null;
  window.swymPageLoad = function(){
    window.SwymProductVariants = window.SwymProductVariants || {};
    window.SwymHasCartItems = null > 0;
    window.SwymPageData = {}, window.SwymProductInfo = {};
    var unknown = {et: 0};
    window.SwymPageData = unknown;
    
    window.SwymPageData.uri = window.swymLandingURL;
  };

  if(window.selectCallback){
    (function(){
      // Variant select override
      var originalSelectCallback = window.selectCallback;
      window.selectCallback = function(variant){
        originalSelectCallback.apply(this, arguments);
        try{
          if(window.triggerSwymVariantEvent){
            window.triggerSwymVariantEvent(variant.id);
          }
        }catch(err){
          console.warn("Swym selectCallback", err);
        }
      };
    })();
  }
  window.swymCustomerId = null;
  var swappName = (null || "Wishlist");
  var swymJSObject = {
    pid: null || "IwNHvuaJRvw+TGS3LOd8XS4peWMbdFC00nWZFMicb/U=",
    interface: "/apps/swym" + swappName + "/interfaces/interfaceStore.php?appname=" + swappName
  };
  window.swymJSShopifyLoad = function(){
    if(window.swymPageLoad) swymPageLoad();
    if(!window._swat) {
      (function (s, w, r, e, l, a, y) {
        r['SwymRetailerConfig'] = s;
        r[s] = r[s] || function (k, v) {
          r[s][k] = v;
        };
      })('_swrc', '', window);
      _swrc('RetailerId', swymJSObject.pid);
      _swrc('Callback', function(){initSwymShopify();});
    }else if(window._swat.postLoader){
      _swrc = window._swat.postLoader;
      _swrc('RetailerId', swymJSObject.pid);
      _swrc('Callback', function(){initSwymShopify();});
    }else{
      initSwymShopify();
    }
  }
  if(!window._SwymPreventAutoLoad) {
    swymJSShopifyLoad();
  }
  window.swymGetCartCookies = function(){
    var RequiredCookies = ["cart", "swym-session-id", "swym-swymRegid", "swym-email"];
    var reqdCookies = {};
    RequiredCookies.forEach(function(k){
      reqdCookies[k] = _swat.storage.getRaw(k);
    });
    var cart_token = window.swymCart.token;
    var data = {
        action:'cart',
        token:cart_token,
        cookies:reqdCookies
    };
    return data;
  }

  window.swymGetCustomerData = function(){
    
    return {status:1};
    
  }

  // part two
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    document.getElementById("safari-flasher-pre").innerHTML = ''
      + '#swym-plugin,#swym-hosted-plugin{display: none;}'
      + '.swym-button.swym-add-to-wishlist{display: none;}'
      + '.swym-button.swym-add-to-watchlist{display: none;}'
      + '#swym-plugin  #swym-notepad, #swym-hosted-plugin  #swym-notepad{opacity: 0; visibility: hidden;}'
      + '#swym-plugin  #swym-notepad, #swym-plugin  #swym-overlay, #swym-plugin  #swym-notification,'
      + '#swym-hosted-plugin  #swym-notepad, #swym-hosted-plugin  #swym-overlay, #swym-hosted-plugin  #swym-notification'
      + '{-webkit-transition: none; transition: none;}'
      + '';
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function(tracker){
      tracker.evtLayer.addEventListener(tracker.JSEvents.configLoaded, function(){
        // flash-preventer
        var x = function(){
          SwymUtils.onDOMReady(function() {
            var d = document.createElement("div");
            d.innerHTML = "<style id='safari-flasher-post'>"
              + "#swym-plugin:not(.swym-ready),#swym-hosted-plugin:not(.swym-ready){display: none;}"
              + ".swym-button.swym-add-to-wishlist:not(.swym-loaded){display: none;}"
              + ".swym-button.swym-add-to-watchlist:not(.swym-loaded){display: none;}"
              + "#swym-plugin.swym-ready  #swym-notepad, #swym-plugin.swym-ready  #swym-overlay, #swym-plugin.swym-ready  #swym-notification,"
              + "#swym-hosted-plugin.swym-ready  #swym-notepad, #swym-hosted-plugin.swym-ready  #swym-overlay, #swym-hosted-plugin.swym-ready  #swym-notification"
              + "{-webkit-transition: opacity 0.3s, visibility 0.3ms, -webkit-transform 0.3ms !important;-moz-transition: opacity 0.3s, visibility 0.3ms, -moz-transform 0.3ms !important;-ms-transition: opacity 0.3s, visibility 0.3ms, -ms-transform 0.3ms !important;-o-transition: opacity 0.3s, visibility 0.3ms, -o-transform 0.3ms !important;transition: opacity 0.3s, visibility 0.3ms, transform 0.3ms !important;}"
              + "</style>";
            document.head.appendChild(d);
          });
        };
        setTimeout(x, 10);
      });
    });
  }

}

/*!*/
/*
Outdated: Hide announcement bar on scroll down, and show it at the top of the page.
window.onload = function() {
  const html = document.querySelector('html');
  if (!html.classList.contains('has-bar')) return;
  
  const mobileSize = 761;
  var stopFunction = false;
  var prevScrollpos = window.pageYOffset;
  
  const bar = document.querySelector("#top-bar");
  
  window.onscroll = function() {
    if (stopFunction) return;
    if (window.innerWidth < mobileSize) {
    	ensurePosition();
    }
  }
  function ensurePosition() {
    if (window.innerWidth < mobileSize) {
      var currentScrollPos = window.pageYOffset < 0 ? 0 : window.pageYOffset;
      if (window.pageYOffset < bar.clientHeight) {
        bar.style.top = "0";
        html.classList.add('has-bar');
      } else {
        bar.style.top = `-${bar.clientHeight}px`;
        html.classList.remove('has-bar');
      }
      prevScrollpos = currentScrollPos;
    }
  }
  function defer(method) {
    const announcementClose = document.querySelector("#top-bar a.close");
    if (announcementClose) {
        method(announcementClose);
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
  }
  defer(dom => {
    dom.onclick = function() {
      stopFunction = true;
      html.classList.remove('has-bar');
    }
  });
}
*/
